export const KEY_ACCESS_TOKEN = 'Access_Token';
export const KEY_CONFIG_URL = 'https://config-api.ken42.com/v1/configs/url';
export const REGEX = {
  NAME: /^[a-zA-Z ]*$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{6,6}$/,
  NUMBER: /[^0-9]/,
  ONLYNUMBER: /^[0-9]*$/,
  NUMBERWITHDECIMAL: /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/,
  DIGITS_ONLY_UPTO_100:
    /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4:
    /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  CGPA: /^10$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9-./, ]*$/,
  MIXED_ADDRESS: /^[a-zA-Z0-9-.#/, ]*$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  AADHAAR: '^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$',
  EMAIL:
    /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zzA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zzA-Z0-9](?:[a-zzA-Z0-9-]*[a-zzA-Z0-9])?\.)+[a-zzA-Z0-9](?:[a-zzA-Z0-9-]*[a-zzA-Z0-9])?/,
  //   EMAIL:
  //     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const ROLES = { APPLICANT: 'APPLICANT', PARTNER: 'PARTNER' };
export const PERMISSIONS = {
  [ROLES.APPLICANT]: {
    APP_HOME: 'APP_HOME',
    APP_APPLICATIONS: 'APP_APPLICATIONS',
    APP_DOCUMENTS: 'APP_DOCUMENTS',
    APP_THANKYOU: 'APP_THANKYOU',
    APP_FEEPAYEMENTS: 'APP_FEEPAYEMENTS',
    APP_COURSES: 'APP_COURSES',
    APP_ONBOARDING: 'APP_ONBOARDING',
    APP_FEEDETAILS: 'APP_FEEDETAILS',
    APP_OFFERLETTERDETAILED: 'APP_OFFERLETTERDETAILED',
    APP_INTERVIEWSLOTS: 'APP_INTERVIEWSLOTS',
    APP_INTERVIEW: 'APP_INTERVIEW',
    APP_OFFERLETTER: 'APP_OFFERLETTER',
    APP_FEESTRUCTURE: 'APP_FEESTRUCTURE',
    APP_HOME_NEW: 'APP_HOME_NEW',
    APP_EVENT: 'APP_EVENT',
  },
  [ROLES.PARTNER]: {
    PAR_HOME: 'PAR_HOME',
    PAR_APPLICATIONS: 'PAR_APPLICATIONS',
  },
};
export const TABLET_BREAKPOINT = 'tablet';

export const QuestionContent = [
  {
    Question:
      'What are the geographical regions currently open for application submissions?',
    Answer:
      'We are accepting applications from India, the Middle East and Africa (MEA), the United States (US), and Singapore.',
  },
  {
    Question: 'What sectors or industries does Turbostart specialize in?',
    Answer:
      ' Turbostart is tech first, sector-agnostic early stage startup fund and accelerator. However, we also provide investment opportunities for startups operating in various other industries such as healthcare, consumer goods, and sustainable energy.',
  },
  {
    Question:
      'What is the typical investment range that Turbostart provides to startups?',
    Answer: `Turbostart primarily focuses on early-stage companies and typically invests between $250k to $1 Million dollars, depending on specific factors such as the startup's growth stage, market potential, and unique requirements.`,
  },
  {
    Question: 'What is the application process?',
    Answer: `Startups can conveniently apply for funding through our user-friendly online application portal. Our meticulous curation team continually reviews applications, progressing through approximately four stages: 
      a) Initial review of online applications, 
      b) In-depth assessment by our internal committee, 
      c) Evaluation by our expert committee, and
       d) Final scrutiny by the Global Investment Committee, culminating in commercial and due diligence discussions.`,
  },
  {
    Question: `What kind of support can startups expect from Turbostart post-investment?`,
    Answer:
      'Apart from financial support, Turbostart provides strategic guidance, access to industry networks, and specialized resources through our Center of Excellence (CoE) offerings, including tech, marketing, sales, investment banking, and a design studio.',
  },
  {
    Question:
      'What criteria does Turbostart consider while selecting startups for investment?',
    Answer: `Turbostart assesses startups based on several factors, including the strength of their business model, market potential, team capabilities, and alignment with Turbostart's vision and values.`,
  },

  {
    Question: `What is the process and timeline for Turbostart's investment decisions?`,
    Answer: `We tentatively make funding decisions within 10-12 weeks of receiving an online application. We require this time to make sure your business gets the time, attention and understanding it deserves from us.`,
  },
  {
    Question: `Does Turbostart provide mentorship or guidance to startups that are not selected for investment?`,
    Answer: `While Turbostart prioritizes startups that align closely with its investment criteria, it aims to support the broader entrepreneurial community through various mentorship initiatives and networking opportunities.`,
  },
  {
    Question: `Can startups from other regions apply to Turbostart in the future, and if so, when?`,
    Answer: `While Turbostart's current focus is on India, MEA, US, and Singapore, it continuously reviews its geographical focus and may consider applications from other regions in the future. Please stay updated on Turbostart's website for any changes in the application criteria.`,
  },
  {
    Question: `What sets Turbostart apart from others in the market?`,
    Answer: `Turbostart stands out due to its deep industry expertise, hands-on approach to fostering growth, and its dedicated efforts to provide comprehensive support through its CoE offerings, aiming to create long-term value for its portfolio startups.`,
  },
  {
    Question: `How can startups get in touch with Turbostart's team for further queries or information?`,
    Answer: `For any inquiries or additional information, please reach out to Turbostart through the contact details provided on its website, and its team will be happy to assist you.`,
  },
];
